/* ------------- Types and Action Creators ------------- */

/*
 * action types
 */
const Types = {
  NOTIFICATIONS_REQUEST: "NOTIFICATIONS_REQUEST",
  NOTIFICATIONS_SUCCESS: "NOTIFICATIONS_SUCCESS",
  NOTIFICATIONS_ERROR: "NOTIFICATIONS_ERROR",
  NOTIFICATIONS_READ_REQUEST: "NOTIFICATIONS_READ_REQUEST",
  NOTIFICATIONS_READ_SUCCESS: "NOTIFICATIONS_READ_SUCCESS",
  NOTIFICATIONS_READ_ALL_REQUEST: "NOTIFICATIONS_READ_ALL_REQUEST",
  NOTIFICATIONS_READ_ALL_SUCCESS: "NOTIFICATIONS_READ_ALL_SUCCESS"
}

/*
 * action creators
 */
const Creators = {
  request: (perPage, offset, append = false) => {
    return {
      type: Types.NOTIFICATIONS_REQUEST,
      perPage,
      offset,
      append
    }
  },

  success: (notifications, unreadCount, append = false) => {
    return {
      type: Types.NOTIFICATIONS_SUCCESS,
      notifications,
      unreadCount,
      append
    }
  },

  error: error => {
    return {
      type: Types.NOTIFICATIONS_ERROR,
      error
    }
  },

  // read single notification
  readNotificationRequest: id => {
    return {
      type: Types.NOTIFICATIONS_READ_REQUEST,
      id
    }
  },

  readNotificationSuccess: (readAt, id) => {
    return {
      type: Types.NOTIFICATIONS_READ_SUCCESS,
      readAt,
      id
    }
  },

  // read all
  readNotificationsAllRequest: () => {
    return {
      type: Types.NOTIFICATIONS_READ_ALL_REQUEST
    }
  },

  readNotificationsAllSuccess: readAt => {
    return {
      type: Types.NOTIFICATIONS_READ_ALL_SUCCESS,
      readAt
    }
  }
}

export const NotificationsCreators = Creators
export const NotificationsTypes = Types

/* ------------- Initial State ------------- */
const initialState = () => {
  return {
    notifications: [],
    unreadCount: 0,
    error: null,
    fetching: false
  }
}

/* ------------- Reducers ------------- */
const request = state => {
  return {...state, fetching: true, error: null}
}

const success = (state, {notifications, unreadCount, append}) => {
  return {
    ...state,
    fetching: false,
    error: null,
    notifications: append
      ? [...state.notifications, notifications]
      : notifications,
    unreadCount
  }
}

const error = (state, {error}) => {
  return {...state, fetching: false, error}
}

const readNotificationSuccess = (state, {readAt, id}) => {
  return {
    ...state,
    notifications: state.notifications.map(notification => {
      if (notification.id === id.toString()) {
        notification.read_at = readAt
      }

      return notification
    }),
    unread_notifications_count: state.unread_notifications_count - 1
  }
}

const readNotificationsAllSuccess = (state, {readAt}) => {
  return {
    ...state,
    notifications: state.notifications.map(notification => {
      if (!notification.readAt) {
        notification.read_at = readAt
      }

      return notification
    }),
    unread_notifications_count: 0
  }
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = (state, action) => {
  if (typeof state === "undefined") {
    return initialState()
  }

  switch (action.type) {
    case Types.NOTIFICATIONS_REQUEST:
      return request(state, action)

    case Types.NOTIFICATIONS_SUCCESS:
      return success(state, action)

    case Types.NOTIFICATIONS_ERROR:
      return error(state, action)

    case Types.NOTIFICATIONS_READ_SUCCESS:
      return readNotificationSuccess(state, action)

    case Types.NOTIFICATIONS_READ_ALL_SUCCESS:
      return readNotificationsAllSuccess(state, action)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Notifications/redux.js